import React from 'react';
import ColorPicker from './ColorPicker';

const StyleCustomization = ({ formData, updateFormData, googleFonts }) => {
  return (
    <div className="form-section-content">
      <h3 className="section-title">Personnalisation du style</h3>
      <div className="form-group">
        <label className="form-label" htmlFor="police">
          Police de caractères
        </label>
        <select
          id="police"
          className="form-select"
          value={formData.police}
          onChange={(e) => updateFormData('police', e.target.value)}
        >
          {googleFonts.map((font) => (
            <option key={font} value={font}>
              {font}
            </option>
          ))}
        </select>
      </div>
      
      <div className="form-group">
        <label className="form-label" htmlFor="taillePolice">
          Taille de police: {formData.taillePolice}px
        </label>
        <input
          type="range"
          id="taillePolice"
          className="form-range"
          min="12"
          max="18"
          value={formData.taillePolice}
          onChange={(e) => updateFormData('taillePolice', parseInt(e.target.value))}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--text-light)', marginTop: '5px' }}>
          <span>12px</span>
          <span>18px</span>
        </div>
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
        <div className="form-group">
          <label className="form-label">
            Couleur du nom
          </label>
          <ColorPicker
            value={formData.couleurNom}
            onChange={(color) => updateFormData('couleurNom', color)}
            placeholder="#000000"
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">
            Couleur d'accent
          </label>
          <ColorPicker
            value={formData.couleurAccent}
            onChange={(color) => updateFormData('couleurAccent', color)}
            placeholder="#FF6B35"
          />
        </div>
      </div>
    </div>
  );
};

export default StyleCustomization;